webpackJsonp([21924764633174],{

/***/ 102:
/***/ (function(module, exports) {

	/**
	 * https://github.com/gre/bezier-easing
	 * BezierEasing - use bezier curve for transition easing function
	 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	 */
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	var float32ArraySupported = typeof Float32Array === 'function';
	
	function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }
	
	function binarySubdivide (aX, aA, aB, mX1, mX2) {
	  var currentX, currentT, i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}
	
	function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	   var currentSlope = getSlope(aGuessT, mX1, mX2);
	   if (currentSlope === 0.0) {
	     return aGuessT;
	   }
	   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	   aGuessT -= currentX / currentSlope;
	 }
	 return aGuessT;
	}
	
	function LinearEasing (x) {
	  return x;
	}
	
	module.exports = function bezier (mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    throw new Error('bezier x values must be in [0, 1] range');
	  }
	
	  if (mX1 === mY1 && mX2 === mY2) {
	    return LinearEasing;
	  }
	
	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  for (var i = 0; i < kSplineTableSize; ++i) {
	    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	  }
	
	  function getTForX (aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;
	
	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;
	
	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;
	
	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  return function BezierEasing (x) {
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	};


/***/ }),

/***/ 452:
/***/ (function(module, exports) {

	function r(e){var o,t,f="";if("string"==typeof e||"number"==typeof e)f+=e;else if("object"==typeof e)if(Array.isArray(e)){var n=e.length;for(o=0;o<n;o++)e[o]&&(t=r(e[o]))&&(f&&(f+=" "),f+=t)}else for(t in e)e[t]&&(f&&(f+=" "),f+=t);return f}function e(){for(var e,o,t=0,f="",n=arguments.length;t<n;t++)(e=arguments[t])&&(o=r(e))&&(f&&(f+=" "),f+=o);return f}module.exports=e,module.exports.clsx=e;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bezierEasing = __webpack_require__(102);
	
	var _bezierEasing2 = _interopRequireDefault(_bezierEasing);
	
	var _windowScrollManager = __webpack_require__(62);
	
	var _windowScrollManager2 = _interopRequireDefault(_windowScrollManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Check if code is running in the browser (important for universal rendering)
	var WINDOW_EXISTS = typeof window !== 'undefined';
	
	// Regex that checks for numbers in string
	// formatted as "{number}{unit}" where unit is "px", "vh", "%" or none
	var START_END_DURATION_REGEX = /^-?\d+(\.\d+)?(px|vh|%)?$/;
	
	var DEFAULT_UNIT = 'px';
	var DEFAULT_ANGLE_UNIT = 'deg';
	var ANGLE_PROPERTIES = ['rotate', 'rotateX', 'rotateY', 'rotateZ', 'skew', 'skewX', 'skewY', 'skewZ', 'hueRotate'];
	
	var EASINGS = {
	  ease: [0.25, 0.1, 0.25, 1.0],
	  easeIn: [0.42, 0.0, 1.00, 1.0],
	  easeOut: [0.00, 0.0, 0.58, 1.0],
	  easeInOut: [0.42, 0.0, 0.58, 1.0],
	  easeInSine: [0.47, 0, 0.745, 0.715],
	  easeOutSine: [0.39, 0.575, 0.565, 1],
	  easeInOutSine: [0.445, 0.05, 0.55, 0.95],
	  easeInQuad: [0.55, 0.085, 0.68, 0.53],
	  easeOutQuad: [0.25, 0.46, 0.45, 0.94],
	  easeInOutQuad: [0.455, 0.03, 0.515, 0.955],
	  easeInCubic: [0.55, 0.055, 0.675, 0.19],
	  easeOutCubic: [0.215, 0.61, 0.355, 1],
	  easeInOutCubic: [0.645, 0.045, 0.355, 1],
	  easeInQuart: [0.895, 0.03, 0.685, 0.22],
	  easeOutQuart: [0.165, 0.84, 0.44, 1],
	  easeInOutQuart: [0.77, 0, 0.175, 1],
	  easeInQuint: [0.755, 0.05, 0.855, 0.06],
	  easeOutQuint: [0.23, 1, 0.32, 1],
	  easeInOutQuint: [0.86, 0, 0.07, 1],
	  easeInExpo: [0.95, 0.05, 0.795, 0.035],
	  easeOutExpo: [0.19, 1, 0.22, 1],
	  easeInOutExpo: [1, 0, 0, 1],
	  easeInCirc: [0.6, 0.04, 0.98, 0.335],
	  easeOutCirc: [0.075, 0.82, 0.165, 1],
	  easeInOutCirc: [0.785, 0.135, 0.15, 0.86]
	};
	
	// Color regexs
	
	// 0 - 199 | 200 - 249 | 250 - 255
	var REGEX_0_255 = '(1?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])';
	// 0.0 - 1.9999...
	var REGEX_0_1 = '([01](\\.\\d+)?)';
	// 00 - FF
	var REGEX_TWO_HEX_DIGITS = '([a-f\\d]{2})';
	
	var HEX_REGEX = new RegExp('^#' + REGEX_TWO_HEX_DIGITS + REGEX_TWO_HEX_DIGITS + REGEX_TWO_HEX_DIGITS + '$', 'i');
	var RGB_REGEX = new RegExp('^rgb\\(' + REGEX_0_255 + ',' + REGEX_0_255 + ',' + REGEX_0_255 + '\\)$', 'i');
	var RGBA_REGEX = new RegExp('^rgba\\(' + REGEX_0_255 + ',' + REGEX_0_255 + ',' + REGEX_0_255 + ',' + REGEX_0_1 + '\\)$', 'i');
	
	var SCROLL_OFFSET = 50;
	
	var RESIZE_DEBOUNCE_TIMEOUT = 150;
	
	// CSS transform map
	var TRANSFORM_MAP = {
	  rotate: function rotate(value, unit) {
	    return 'rotate(' + value + unit + ')';
	  },
	  rotateX: function rotateX(value, unit) {
	    return 'rotateX(' + value + unit + ')';
	  },
	  rotateY: function rotateY(value, unit) {
	    return 'rotateY(' + value + unit + ')';
	  },
	  rotateZ: function rotateZ(value, unit) {
	    return 'rotateZ(' + value + unit + ')';
	  },
	  scale: function scale(value) {
	    return 'scale(' + value + ')';
	  },
	  scaleX: function scaleX(value) {
	    return 'scaleX(' + value + ')';
	  },
	  scaleY: function scaleY(value) {
	    return 'scaleY(' + value + ')';
	  },
	  scaleZ: function scaleZ(value) {
	    return 'scaleZ(' + value + ')';
	  },
	  skew: function skew(value, unit) {
	    return 'skew(' + value + unit + ')';
	  },
	  skewX: function skewX(value, unit) {
	    return 'skewX(' + value + unit + ')';
	  },
	  skewY: function skewY(value, unit) {
	    return 'skewY(' + value + unit + ')';
	  },
	  skewZ: function skewZ(value, unit) {
	    return 'skewZ(' + value + unit + ')';
	  },
	  translateX: function translateX(value, unit) {
	    return 'translateX(' + value + unit + ')';
	  },
	  translateY: function translateY(value, unit) {
	    return 'translateY(' + value + unit + ')';
	  },
	  translateZ: function translateZ(value, unit) {
	    return 'translateZ(' + value + unit + ')';
	  }
	};
	
	// Order of CSS transforms matters
	var ORDER_OF_TRANSFORMS = ['translateX', 'translateY', 'translateZ', 'skew', 'skewX', 'skewY', 'skewZ', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'scaleZ'];
	
	// CSS properties that use color values
	var COLOR_PROPERTIES = ['backgroundColor', 'borderBottomColor', 'borderColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor', 'color', 'fill', 'strokeColor'];
	
	// CSS filter map
	// blur()
	// brightness()
	// contrast()
	// grayscale()
	// hue-rotate()
	// invert()
	// opacity() // use opacityFilter
	// saturate()
	// sepia()
	
	// Not supported
	// drop-shadow()
	// url()
	var FILTER_MAP = {
	  blur: function blur(value, unit) {
	    return 'blur(' + value + unit + ')';
	  },
	  brightness: function brightness(value) {
	    return 'brightness(' + value + ')';
	  },
	  contrast: function contrast(value) {
	    return 'contrast(' + value + ')';
	  },
	  grayscale: function grayscale(value) {
	    return 'grayscale(' + value + ')';
	  },
	  hueRotate: function hueRotate(value, unit) {
	    return 'hue-rotate(' + value + unit + ')';
	  },
	  invert: function invert(value) {
	    return 'invert(' + value + ')';
	  },
	  opacityFilter: function opacityFilter(value) {
	    return 'opacity(' + value + ')';
	  },
	  saturate: function saturate(value) {
	    return 'saturate(' + value + ')';
	  },
	  sepia: function sepia(value) {
	    return 'sepia(' + value + ')';
	  }
	};
	
	var FILTER_PROPERTIES = ['blur', 'brightness', 'contrast', 'grayscale', 'hueRotate', 'invert', 'opacityFilter', 'saturate', 'sepia'];
	
	// Props to be removed from passing directly to the component element
	var PROPS_TO_OMIT = ['animateWhenNotInViewport', 'children', 'className', 'freeze', 'parallaxData', 'style', 'tagName'];
	
	// Get element's top offset
	function getElementTop(el) {
	  var top = 0;
	  var element = el;
	
	  do {
	    top += element.offsetTop || 0;
	    element = element.offsetParent;
	  } while (element);
	
	  return top;
	}
	
	// Returns CSS unit
	function getUnit(property, unit) {
	  var propertyUnit = unit || DEFAULT_UNIT;
	
	  if (ANGLE_PROPERTIES.indexOf(property) >= 0) {
	    propertyUnit = unit || DEFAULT_ANGLE_UNIT;
	  }
	
	  return propertyUnit;
	}
	
	// Takes string value (in px/vh/%) and returns number
	function getValueInPx(value, maxScroll) {
	  var floatValue = parseFloat(value);
	  var unit = value.match(START_END_DURATION_REGEX)[2] || null;
	  var vh = window.innerHeight / 100;
	  var valueInPx = value;
	
	  switch (unit) {
	    case 'vh':
	      valueInPx = vh * floatValue;
	      break;
	    case '%':
	      valueInPx = maxScroll * floatValue / 100;
	      break;
	    default:
	      valueInPx = floatValue;
	  }
	
	  return valueInPx;
	}
	
	// Takes start/end/duration props
	// and return number (in pixels) based on prop type (number, string, dom element)
	function convertPropToPixels(propName, propValue, maxScroll) {
	  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  var propValueInPx = propValue;
	  var isElement = propValue instanceof HTMLElement;
	  var keyCodes = {
	    ZERO: 48,
	    NINE: 57
	  };
	
	  if (typeof propValue === 'number') {
	    propValueInPx = propValue;
	  } else if (START_END_DURATION_REGEX.test(propValue)) {
	    propValueInPx = getValueInPx(propValue, maxScroll);
	  } else if (isElement || typeof propValue === 'string' && (propValue.charCodeAt(0) < keyCodes.ZERO || propValue.charCodeAt(0) > keyCodes.NINE)) {
	    var element = isElement ? propValue : document.querySelector(propValue);
	
	    if (!element) {
	      console.warn('Plx, ERROR: ' + propName + ' selector matches no elements: "' + propValue + '"'); // eslint-disable-line
	      return null;
	    }
	
	    if (propName === 'start' || propName === 'end') {
	      // START or END
	      // Element enters the viewport
	      propValueInPx = getElementTop(element) - window.innerHeight;
	    } else if (propName === 'duration') {
	      // DURATION
	      // Height of the element
	      propValueInPx = element.offsetHeight;
	    }
	  } else {
	    console.warn('Plx, ERROR: "' + propValue + '" is not a valid ' + propName + ' value, check documenation'); // eslint-disable-line
	    return null;
	  }
	
	  // Transform offset to px
	  var offsetInPx = 0;
	
	  if (typeof offset === 'number') {
	    offsetInPx = offset;
	  } else if (START_END_DURATION_REGEX.test(offset)) {
	    offsetInPx = getValueInPx(offset, maxScroll);
	  }
	  // Add offset
	  propValueInPx += offsetInPx;
	
	  if (propValueInPx < 0) {
	    propValueInPx = 0;
	  }
	
	  return propValueInPx;
	}
	
	// Convers color in hex format into object { r, g, b, a }
	function hexToObject(hex) {
	  // Convert #abc to #aabbcc
	  var color = hex.length === 4 ? '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3] : hex;
	  var result = HEX_REGEX.exec(color);
	
	  // Safety check, if color is in the wrong format
	  if (!result) {
	    console.warn('Plx, ERROR: hex color is not in the right format: "' + hex + '"'); // eslint-disable-line no-console
	    return null;
	  }
	
	  // All color functions are returning { r, g, b, a } object
	  return {
	    r: parseInt(result[1], 16),
	    g: parseInt(result[2], 16),
	    b: parseInt(result[3], 16),
	    a: 1
	  };
	}
	
	// Convers color in rgb format into object { r, g, b, a }
	function rgbToObject(rgb) {
	  var isRgba = rgb.toLowerCase().indexOf('rgba') === 0;
	  var color = rgb.replace(/ /g, '');
	  var result = isRgba ? RGBA_REGEX.exec(color) : RGB_REGEX.exec(color);
	
	  // Safety check, if color is in the wrong format
	  if (!result) {
	    console.warn('Plx, ERROR: rgb or rgba color is not in the right format: "' + rgb + '"'); // eslint-disable-line
	    return null;
	  }
	
	  // All color functions are returning { r, g, b, a } object
	  return {
	    r: parseInt(result[1], 10),
	    g: parseInt(result[2], 10),
	    b: parseInt(result[3], 10),
	    a: isRgba ? parseFloat(result[4]) : 1
	  };
	}
	
	// Calculates the current value for parallaxing property
	function parallax(scrollPosition, start, duration, startValue, endValue, easing) {
	  var min = startValue;
	  var max = endValue;
	  var invert = startValue > endValue;
	
	  // Safety check, if "startValue" is in the wrong format
	  if (typeof startValue !== 'number') {
	    console.warn('Plx, ERROR: startValue is not a number (type: "' + (typeof endValue === 'undefined' ? 'undefined' : _typeof(endValue)) + '", value: "' + endValue + '")'); // eslint-disable-line
	    return null;
	  }
	
	  // Safety check, if "endValue" is in the wrong format
	  if (typeof endValue !== 'number') {
	    console.warn('Plx, ERROR: endValue is not a number (type: "' + (typeof endValue === 'undefined' ? 'undefined' : _typeof(endValue)) + '", value: "' + endValue + '")'); // eslint-disable-line
	    return null;
	  }
	
	  // Safety check, if "duration" is in the wrong format
	  if (typeof duration !== 'number' || duration === 0) {
	    console.warn('Plx, ERROR: duration is zero or not a number (type: "' + (typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) + '", value: "' + duration + '")'); // eslint-disable-line
	    return null;
	  }
	
	  if (invert) {
	    min = endValue;
	    max = startValue;
	  }
	
	  var percentage = (scrollPosition - start) / duration;
	
	  if (percentage > 1) {
	    percentage = 1;
	  } else if (percentage < 0) {
	    percentage = 0;
	  }
	
	  // Apply easing
	  if (easing) {
	    var easingPropType = typeof easing === 'undefined' ? 'undefined' : _typeof(easing);
	    if (easingPropType === 'object' && easing.length === 4) {
	      percentage = (0, _bezierEasing2.default)(easing[0], easing[1], easing[2], easing[3])(percentage);
	    } else if (easingPropType === 'string' && EASINGS[easing]) {
	      percentage = (0, _bezierEasing2.default)(EASINGS[easing][0], EASINGS[easing][1], EASINGS[easing][2], EASINGS[easing][3])(percentage);
	    } else if (easingPropType === 'function') {
	      percentage = easing(percentage);
	    }
	  }
	
	  var value = percentage * (max - min);
	
	  if (invert) {
	    value = max - value;
	  } else {
	    value += min;
	  }
	
	  return parseFloat(value.toFixed(3));
	}
	
	// Calculates current value for color parallax
	function colorParallax(scrollPosition, start, duration, startValue, endValue, easing) {
	  var startObject = null;
	  var endObject = null;
	
	  if (startValue[0].toLowerCase() === 'r') {
	    startObject = rgbToObject(startValue);
	  } else {
	    startObject = hexToObject(startValue);
	  }
	
	  if (endValue[0].toLowerCase() === 'r') {
	    endObject = rgbToObject(endValue);
	  } else {
	    endObject = hexToObject(endValue);
	  }
	
	  if (startObject && endObject) {
	    var r = parallax(scrollPosition, start, duration, startObject.r, endObject.r, easing);
	    var g = parallax(scrollPosition, start, duration, startObject.g, endObject.g, easing);
	    var b = parallax(scrollPosition, start, duration, startObject.b, endObject.b, easing);
	    var a = parallax(scrollPosition, start, duration, startObject.a, endObject.a, easing);
	
	    return 'rgba(' + parseInt(r, 10) + ', ' + parseInt(g, 10) + ', ' + parseInt(b, 10) + ', ' + a + ')';
	  }
	
	  return null;
	}
	
	// Applies property parallax to the style object
	function applyProperty(scrollPosition, propertyData, startPosition, duration, style, easing) {
	  var startValue = propertyData.startValue,
	      endValue = propertyData.endValue,
	      property = propertyData.property,
	      unit = propertyData.unit;
	
	  // If property is one of the color properties
	  // Use it's parallax method
	
	  var isColor = COLOR_PROPERTIES.indexOf(property) > -1;
	  var parallaxMethod = isColor ? colorParallax : parallax;
	
	  // Get new CSS value
	  var value = parallaxMethod(scrollPosition, startPosition, duration, startValue, endValue, easing);
	
	  // Get transform function
	  var transformMethod = TRANSFORM_MAP[property];
	  var filterMethod = FILTER_MAP[property];
	  var newStyle = style;
	
	  if (transformMethod) {
	    // Get CSS unit
	    var propertyUnit = getUnit(property, unit);
	    // Transforms, apply value to transform function
	    newStyle.transform[property] = transformMethod(value, propertyUnit);
	  } else if (filterMethod) {
	    // Get CSS unit
	    var _propertyUnit = getUnit(property, unit);
	    // Filters, apply value to filter function
	    newStyle.filter[property] = filterMethod(value, _propertyUnit);
	  } else {
	    // All other properties
	    newStyle[property] = value;
	
	    // Add unit if it is passed
	    if (unit) {
	      newStyle[property] += unit;
	    }
	  }
	
	  return newStyle;
	}
	
	// Returns CSS classes based on animation state
	function getClasses(lastSegmentScrolledBy, isInSegment, parallaxData) {
	  var cssClasses = null;
	
	  if (lastSegmentScrolledBy === null) {
	    cssClasses = 'Plx--above';
	  } else if (lastSegmentScrolledBy === parallaxData.length - 1 && !isInSegment) {
	    cssClasses = 'Plx--below';
	  } else if (lastSegmentScrolledBy !== null && isInSegment) {
	    var segmentName = parallaxData[lastSegmentScrolledBy].name || lastSegmentScrolledBy;
	
	    cssClasses = 'Plx--active Plx--in Plx--in-' + segmentName;
	  } else if (lastSegmentScrolledBy !== null && !isInSegment) {
	    var _segmentName = parallaxData[lastSegmentScrolledBy].name || lastSegmentScrolledBy;
	    var nextSegmentName = parallaxData[lastSegmentScrolledBy + 1].name || lastSegmentScrolledBy + 1;
	
	    cssClasses = 'Plx--active Plx--between Plx--between-' + _segmentName + '-and-' + nextSegmentName;
	  }
	
	  return cssClasses;
	}
	
	// Omits "keysToOmit" from "object"
	function omit(object, keysToOmit) {
	  var result = {};
	
	  Object.keys(object).forEach(function (key) {
	    if (keysToOmit.indexOf(key) === -1) {
	      result[key] = object[key];
	    }
	  });
	
	  return result;
	}
	
	// Main update function
	// Returns new state object based on props and scroll position
	function getNewState(scrollPosition, props, state, element) {
	  var animateWhenNotInViewport = props.animateWhenNotInViewport,
	      disabled = props.disabled,
	      freeze = props.freeze,
	      parallaxData = props.parallaxData;
	  var showElement = state.showElement,
	      plxStyle = state.plxStyle,
	      plxStateClasses = state.plxStateClasses;
	
	  // Do nothing if animation is disabled, frozen
	  // or if element is not rendered yet
	
	  if (freeze && showElement || !element || disabled) {
	    return null;
	  }
	
	  // Check if element is in viewport
	  // Small offset is added to prevent page jumping
	  if (!animateWhenNotInViewport) {
	    var rect = element.getBoundingClientRect();
	    var isTopAboveBottomEdge = rect.top < window.innerHeight + SCROLL_OFFSET;
	    var isBottomBelowTopEdge = rect.top + rect.height > -SCROLL_OFFSET;
	
	    if (!isTopAboveBottomEdge || !isBottomBelowTopEdge) {
	      return null;
	    }
	  }
	
	  var newState = {};
	
	  // Style to be applied to our element
	  var newStyle = {
	    transform: {},
	    filter: {}
	  };
	
	  // This means "componentDidMount" did happen and that we should show our element
	  if (!showElement) {
	    newState.showElement = true;
	  }
	
	  var appliedProperties = [];
	  var segments = [];
	  var isInSegment = false;
	  var lastSegmentScrolledBy = null;
	  var maxScroll = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
	
	  var _loop = function _loop(i) {
	    var _parallaxData$i = parallaxData[i],
	        duration = _parallaxData$i.duration,
	        easing = _parallaxData$i.easing,
	        endOffset = _parallaxData$i.endOffset,
	        properties = _parallaxData$i.properties,
	        startOffset = _parallaxData$i.startOffset;
	
	
	    var start = parallaxData[i].start === 'self' ? element : parallaxData[i].start;
	    var end = parallaxData[i].end === 'self' ? element : parallaxData[i].end;
	
	    var startInPx = convertPropToPixels('start', start, maxScroll, startOffset);
	    var durationInPx = null;
	    var endInPx = null;
	
	    // End has higher priority than duration
	    if (typeof end !== 'undefined') {
	      endInPx = convertPropToPixels('end', end, maxScroll, endOffset);
	      durationInPx = endInPx - startInPx;
	    } else {
	      durationInPx = convertPropToPixels('duration', duration, maxScroll);
	      endInPx = startInPx + durationInPx;
	    }
	
	    // If segment is below scroll position skip it
	    if (scrollPosition < startInPx) {
	      return 'break';
	    }
	
	    var isScrolledByStart = scrollPosition >= startInPx;
	
	    if (isScrolledByStart) {
	      lastSegmentScrolledBy = i;
	    }
	
	    // If active segment exists, apply his properties
	    if (scrollPosition >= startInPx && scrollPosition <= endInPx) {
	      isInSegment = true;
	
	      properties.forEach(function (propertyData) {
	        // eslint-disable-line no-loop-func
	        var property = propertyData.property;
	
	        // Save which properties are applied to the active segment
	        // So they are not re-applied for other segments
	
	        appliedProperties.push(property);
	
	        // Apply property style
	        newStyle = applyProperty(scrollPosition, propertyData, startInPx, durationInPx, newStyle, easing);
	      });
	    } else {
	      // Push non active segments above the scroll position to separate array
	      // This way "durationInPx" and "startInPx" are not calculated again
	      // and segments below scroll position are skipped in the next step
	      segments.push({
	        easing: easing,
	        durationInPx: durationInPx,
	        properties: properties,
	        startInPx: startInPx
	      });
	    }
	  };
	
	  for (var i = 0; i < parallaxData.length; i++) {
	    var _ret = _loop(i);
	
	    if (_ret === 'break') break;
	  }
	
	  // These are only segments that are completly above scroll position
	  segments.forEach(function (data) {
	    var easing = data.easing,
	        durationInPx = data.durationInPx,
	        properties = data.properties,
	        startInPx = data.startInPx;
	
	
	    properties.forEach(function (propertyData) {
	      var property = propertyData.property;
	
	      // Skip propery that was changed for active segment
	
	      if (appliedProperties.indexOf(property) > -1) {
	        return;
	      }
	
	      // These styles that are the ones changed by segments
	      // that are above active segment
	      newStyle = applyProperty(scrollPosition, propertyData, startInPx, durationInPx, newStyle, easing);
	    });
	  });
	
	  // Sort transforms by ORDER_OF_TRANSFORMS
	  // as order of CSS transforms matters
	  var transformsOrdered = [];
	
	  ORDER_OF_TRANSFORMS.forEach(function (transformKey) {
	    if (newStyle.transform[transformKey]) {
	      transformsOrdered.push(newStyle.transform[transformKey]);
	    }
	  });
	
	  // Concat transforms and add browser prefixes
	  newStyle.transform = transformsOrdered.join(' ');
	  newStyle.WebkitTransform = newStyle.transform;
	  newStyle.MozTransform = newStyle.transform;
	  newStyle.OTransform = newStyle.transform;
	  newStyle.msTransform = newStyle.transform;
	
	  var filtersArray = [];
	  FILTER_PROPERTIES.forEach(function (filterKey) {
	    if (newStyle.filter[filterKey]) {
	      filtersArray.push(newStyle.filter[filterKey]);
	    }
	  });
	
	  // Concat filters and add browser prefixes
	  newStyle.filter = filtersArray.join(' ');
	  newStyle.WebkitFilter = newStyle.filter;
	  newStyle.MozFilter = newStyle.filter;
	  newStyle.OFilter = newStyle.filter;
	  newStyle.msFilter = newStyle.filter;
	
	  // "Stupid" check if style should be updated
	  if (JSON.stringify(plxStyle) !== JSON.stringify(newStyle)) {
	    newState.plxStyle = newStyle;
	  }
	
	  // Adding state class
	  var newPlxStateClasses = getClasses(lastSegmentScrolledBy, isInSegment, parallaxData);
	
	  if (newPlxStateClasses !== plxStateClasses) {
	    newState.plxStateClasses = newPlxStateClasses;
	  }
	
	  if (Object.keys(newState).length) {
	    return newState;
	  }
	
	  return null;
	}
	
	var Plx = function (_Component) {
	  _inherits(Plx, _Component);
	
	  function Plx(props) {
	    _classCallCheck(this, Plx);
	
	    // Binding handlers
	    var _this = _possibleConstructorReturn(this, (Plx.__proto__ || Object.getPrototypeOf(Plx)).call(this, props));
	
	    _this.handleScrollChange = _this.handleScrollChange.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	
	    _this.state = {
	      element: null,
	      showElement: false,
	      plxStateClasses: '',
	      plxStyle: {}
	    };
	    return _this;
	  }
	
	  _createClass(Plx, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Get scroll manager singleton
	      this.scrollManager = new _windowScrollManager2.default();
	      // Add listeners
	      window.addEventListener('window-scroll', this.handleScrollChange);
	      window.addEventListener('resize', this.handleResize);
	
	      this.update();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps !== this.props) {
	        this.update();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var scrollManager = this.state.scrollManager;
	
	
	      window.removeEventListener('window-scroll', this.handleScrollChange);
	      window.removeEventListener('resize', this.handleResize);
	
	      clearTimeout(this.resizeDebounceTimeoutID);
	      this.resizeDebounceTimeoutID = null;
	
	      if (scrollManager) {
	        scrollManager.removeListener();
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this2 = this;
	
	      var scrollPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var currentScrollPosition = scrollPosition === null ? this.scrollManager.getScrollPosition().scrollPositionY : scrollPosition;
	
	      var newState = getNewState(currentScrollPosition, this.props, this.state, this.element);
	
	      if (newState) {
	        // TODO add real tests if requestAnimationFrame is more performant in this case
	        // as window-scroll-manager already uses to fire scroll change events
	        requestAnimationFrame(function () {
	          return _this2.setState(newState);
	        });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var _this3 = this;
	
	      clearTimeout(this.resizeDebounceTimeoutID);
	      this.resizeDebounceTimeoutID = setTimeout(function () {
	        _this3.update();
	      }, RESIZE_DEBOUNCE_TIMEOUT);
	    }
	  }, {
	    key: 'handleScrollChange',
	    value: function handleScrollChange(e) {
	      this.update(e.detail.scrollPositionY);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          style = _props.style,
	          tagName = _props.tagName;
	      var _state = this.state,
	          showElement = _state.showElement,
	          plxStyle = _state.plxStyle,
	          plxStateClasses = _state.plxStateClasses;
	
	
	      var Tag = tagName;
	
	      var elementStyle = style;
	
	      if (!disabled) {
	        elementStyle = _extends({}, style, plxStyle, {
	          // Hide element before until it is rendered
	          // This prevents jumps if page is scrolled and then refreshed
	          visibility: showElement ? null : 'hidden'
	        });
	      }
	
	      return _react2.default.createElement(
	        Tag,
	        _extends({}, omit(this.props, PROPS_TO_OMIT), {
	          className: 'Plx ' + plxStateClasses + ' ' + className,
	          style: elementStyle,
	          ref: function ref(el) {
	            return _this4.element = el;
	          }
	        }),
	        children
	      );
	    }
	  }]);
	
	  return Plx;
	}(_react.Component);
	
	exports.default = Plx;
	
	
	var propertiesItemType = _propTypes2.default.shape({
	  startValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  endValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  property: _propTypes2.default.string.isRequired,
	  unit: _propTypes2.default.string
	});
	
	// Check for the universal rendering
	// HTMLElement in the proptypes breaks on server
	// https://github.com/Stanko/react-plx/issues/25
	var SafeHTMLElement = WINDOW_EXISTS ? window.HTMLElement : {};
	
	var parallaxDataType = _propTypes2.default.shape({
	  start: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.instanceOf(SafeHTMLElement)]).isRequired,
	  startOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  duration: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.instanceOf(SafeHTMLElement)]),
	  end: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.instanceOf(SafeHTMLElement)]),
	  endOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  properties: _propTypes2.default.arrayOf(propertiesItemType).isRequired,
	  easing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.func]),
	  name: _propTypes2.default.string
	});
	
	Plx.propTypes = {
	  animateWhenNotInViewport: _propTypes2.default.bool,
	  children: _propTypes2.default.any,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  freeze: _propTypes2.default.bool,
	  parallaxData: _propTypes2.default.arrayOf(parallaxDataType),
	  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object])),
	  tagName: _propTypes2.default.string
	};
	
	Plx.defaultProps = {
	  animateWhenNotInViewport: false,
	  children: null,
	  className: '',
	  disabled: false,
	  freeze: false,
	  parallaxData: [],
	  style: {},
	  tagName: 'div'
	};

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScrollManager = undefined;
	
	var _windowScrollManager = __webpack_require__(62);
	
	var _windowScrollManager2 = _interopRequireDefault(_windowScrollManager);
	
	var _Plx = __webpack_require__(116);
	
	var _Plx2 = _interopRequireDefault(_Plx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Plx2.default;
	exports.ScrollManager = _windowScrollManager2.default;

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	(function() {
	  var instance = null;
	  var instancesCount = 0;
	  var ticking = false;
	
	  var EVENT_NAME = 'window-scroll';
	
	  // ------------------------------------------------
	  // Passive events support detection
	  // ------------------------------------------------
	  function detectPassiveEvents() {
	    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
	      var passive = false;
	      var options = Object.defineProperty({}, 'passive', {
	        get: function() { passive = true; }
	      });
	      // note: have to set and remove a no-op listener instead of null
	      // (which was used previously), becasue Edge v15 throws an error
	      // when providing a null callback.
	      // https://github.com/rafrex/detect-passive-events/pull/3
	      var noop = function() {};
	      window.addEventListener('testPassiveEventSupport', noop, options);
	      window.removeEventListener('testPassiveEventSupport', noop, options);
	
	      return passive;
	    }
	
	    return false;
	  }
	
	  var supportsPassiveEvents = detectPassiveEvents();
	
	  // ------------------------------------------------
	  // CustomEvent polyfill
	  // ------------------------------------------------
	  if (typeof window !== 'undefined' && typeof window.CustomEvent !== 'function') {
	    var CustomEventPollyfill = function(event, userParams) {
	      var params = {
	        bubbles: userParams.bubbles || false,
	        cancelable: userParams.cancelable || false,
	        detail: userParams.detail || undefined // eslint-disable-line no-undefined
	      };
	      var evt = document.createEvent('CustomEvent');
	      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	      return evt;
	    };
	
	    CustomEventPollyfill.prototype = window.Event.prototype;
	
	    window.CustomEvent = CustomEventPollyfill;
	  }
	
	  // ------------------------------------------------
	  // Scroll manager
	  // ------------------------------------------------
	  function ScrollManager() {
	    if (typeof window === 'undefined') {
	      // Silently return null if it is used on server
	      return null;
	    }
	
	    // Increase reference count
	    instancesCount++;
	
	    // If singleton instance exists, return it rather than creating a new one
	    if (instance) {
	      return instance;
	    }
	
	    // Save singleton instance
	    instance = this;
	
	    // Bind handlers
	    this.handleScroll = this.handleScroll.bind(this);
	
	    // Use passive listener when supported with fallback to capture option
	    this.eventListenerOptions = supportsPassiveEvents ? { passive: true } : true;
	
	    // Add scroll listener
	    window.addEventListener('scroll', this.handleScroll, this.eventListenerOptions);
	  }
	
	  ScrollManager.prototype.removeListener = function() {
	    instancesCount--;
	
	    // There is not components listening to our event
	    if (instancesCount === 0) {
	      this.destroy();
	    }
	  };
	
	  ScrollManager.prototype.destroy = function() {
	    // Remove event listener
	    window.removeEventListener('scroll', this.handleScroll, this.eventListenerOptions);
	
	    // Clear singleton instance and count
	    instance = null;
	    instancesCount = 0;
	  };
	
	  ScrollManager.prototype.getScrollPosition = function() {
	    // Get scroll position, with IE fallback
	    var scrollPositionY = window.scrollY || document.documentElement.scrollTop;
	    var scrollPositionX = window.scrollX || document.documentElement.scrollLeft;
	
	    // Disable overscrolling in safari
	    if (scrollPositionY < 0) {
	      scrollPositionY = 0;
	    }
	    if (scrollPositionX < 0) {
	      scrollPositionX = 0;
	    }
	
	    return {
	      scrollPositionY: scrollPositionY,
	      // Alias for scrollPositionY for backwards compatibility
	      scrollPosition: scrollPositionY,
	      scrollPositionX: scrollPositionX
	    };
	  };
	
	  ScrollManager.prototype.handleScroll = function() {
	    // Fire the event only once per requestAnimationFrame
	    if (!ticking) {
	      ticking = true;
	      var self = this;
	
	      window.requestAnimationFrame(function() {
	        var event = new CustomEvent(EVENT_NAME, {
	          detail: self.getScrollPosition()
	        });
	
	        // Dispatch the event.
	        window.dispatchEvent(event);
	        ticking = false;
	      });
	    }
	  };
	
	  if (typeof module !== 'undefined' && module.exports) {
	    ScrollManager.default = ScrollManager;
	    module.exports = ScrollManager;
	  } else if (true) { // eslint-disable-line no-undef
	    // register as 'window-scroll-manager', consistent with npm package name
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { // eslint-disable-line no-undef
	      return ScrollManager;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    window.ScrollManager = ScrollManager;
	  }
	}).call(this);


/***/ }),

/***/ 1209:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDIzODEuNSA1NTUuMyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDA7c3Ryb2tlLXdpZHRoOjB9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzM0LjYgMjg0LjZjLTEuNCAxLjQtMi4yIDIuOS0yLjMgNC44IDAgMS42LjYgMi45IDEuNiAzLjggMS4xIDEgMi42IDEuNCA0LjUgMS40czQtLjUgNS43LTEuNGMxLjYtLjkgMi45LTIgMy44LTMuM3YtNy41aC02LjhjLTIuOSAwLTUuMS43LTYuNSAyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTQxNS41IDEzOC41Yy03NC4xIDAtMTM0LjEgNjAtMTM0LjEgMTM0LjFzNjAgMTM0LjEgMTM0LjEgMTM0LjEgMTM0LjEtNjAgMTM0LjEtMTM0LjEtNjAtMTM0LjEtMTM0LjEtMTM0LjFtODguMyAxMTguNmM1LjMgMCA5LjYgNC4zIDkuNiA5LjZzLTQuMyA5LjYtOS42IDkuNi05LjYtNC4zLTkuNi05LjYgNC4zLTkuNiA5LjYtOS42bS0xMzYuNSA0Ny44aC0xNi44di0uMmMtLjUtLjktLjktMS43LTEuMi0yLjctLjMtLjctLjQtMS41LS42LTIuMS0xLjYgMS43LTMuNiAzLjItNS44IDQuMnEtMy42IDEuOC04LjQgMS44Yy01LjIgMC05LjMtMS40LTEyLjQtNC4yLTMuMS0yLjktNC42LTYuNy00LjYtMTEuNnMyLTguOSA2LjEtMTEuNmMzLjktMi43IDkuOS00IDE3LjUtNGg2Ljh2LTQuOGMwLTIuNC0uNy00LjItMi01LjZzLTMuNS0yLTYuMS0yLTMgLjItNC4yLjZjLTEuMi4zLTIgLjctMi44IDEuMWwtMSA1LjhoLTExLjJ2LTEyLjFjLjEgMCAuMy0uMS4zLS4xIDIuNi0xLjcgNS42LTMuMyA4LjktNC40IDMuMy0xLjIgNy0xLjggMTEtMS44IDYuNSAwIDExLjkgMS42IDE2IDQuOCA0IDMuMyA2LjEgNy45IDYuMSAxMy44djIwYzAgLjcuMSAxLjguMSAyLjVsNC4zLjZWMzA1Wm0zMC45LS41aC0uM2MtMS41LjYtMy4yLjktNC43IDEuMnMtMy4zLjQtNS4xLjRjLTQuOSAwLTguNy0xLjQtMTEuNC00LjEtMi43LTIuOC00LTcuMS00LTEzdi0yNi4zaC02LjFsLTQtMTAuNmgxMC4xdi0xMi44aDE0LjdWMjUyaDkuNHYxMC42aC05LjR2MjYuM2MwIDEuOS40IDMuNCAxLjEgNC4xLjkuOCAxLjggMS4xIDMuMiAxLjFzMS44IDAgMi41LS4xYy43IDAgMS41LS4yIDIuNC0uNGwxLjctLjZ2MTEuM1ptMzAuOCAwaC0uM2MtLjYuMy0xIC40LTEuNC42LS42LjItMS4yLjQtMi4xLjYtMS41LjMtMy4zLjQtNS4xLjQtNC45IDAtOC43LTEuNC0xMS40LTQuMS0yLjctMi44LTQtNy4xLTQtMTN2LTI2LjNoLTQuMlYyNTJoNC4xdi0xMi44aDE0LjdWMjUyaDkuMXYxMC42aC05LjF2MjYuMmMwIDEuOS40IDMuNCAxLjEgNC4xIDEgMS4xIDIuMSAxLjUgMy4yIDEuNXMxLjggMCAyLjUtLjFjLjgtLjEgMS41LS4yIDIuNC0uNGguNHYxMC42Wm01OC45LjZoLTIzLjN2LTExLjNsNC42LTEuNHYtMjAuMmMwLTMuNC0uNy01LjktMi03LjItMS4zLTEuNS0zLjQtMi4xLTYuMS0yLjFzLTMuNS4zLTQuOSAxLjFxLTIuMSAxLjA1LTMuNiAzdjI1LjNsNC4zIDEuNHYxMS4zaC0yMy4xdi0xMS40bDMuOS0xLjRWMjY0bC00LjctMS40di0xMC43aDE4LjVsLjYgNi44YzEuNi0yLjMgMy42LTQuMSA2LTUuNSAyLjYtMS41IDUuNi0yLjMgOC43LTIuMyA1LjMgMCA5LjYgMS43IDEyLjYgNS4xcTQuNSA1LjEgNC41IDE1Ljl2MjAuMmwzLjkgMS40VjMwNVptMTUuOS44Yy01LjMgMC05LjYtNC4zLTkuNi05LjZzNC4zLTkuNiA5LjYtOS42IDkuNiA0LjMgOS42IDkuNi00LjMgOS42LTkuNiA5LjZtMjUzLjkgMTExLjljLTUuNiAwLTEwLjEtMi4zLTEzLjQtNi43LTMuMy00LjgtOS43LTM3LjgtMTYuNS03NC0xLjYtOC43LTMtMTUuOS0zLjktMjAuMS0yNS40IDcuOS01OS41IDE0LjMtNzQuMiAxN2wtMi43LjVjLTQuNiAxMC43LTcuOSAyMi40LTExLjEgMzMuOGwtMy4zIDExLjR2LjNjLTMuMiA5LjktNS4xIDE1LjgtMTYuOCAxNS44cy0yMi42LTYuNi0yNC0yMWMtMi4zLTIyLjUgMjIuNy04OCAzNy45LTEyNSAxOC4xLTQ0LjQgNDIuMS05Ni42IDQ3LTEwMCA5LjUtNi40IDIyLjEtMTAuMyAzMi43LTEwLjNzMTYuOSA0LjQgMTkuNiAxMS4xYzE3LjYgNDEuOCA1MC4yIDE5MS4xIDU0LjQgMjMzLjkgMSA4LjEuNSAxNS0xLjMgMTguNC00LjggOC4yLTE1LjcgMTQuOS0yNC40IDE0LjltLTU3LjYtMjIxLjFjLTQuNSA4LjQtMjAuOSA0Ny43LTM1LjEgODYuNSAyMi40LTguNyAzOC45LTEyLjcgNDcuNy0xNC40LTEtNS44LTIuMy0xMy42LTMuNi0yMS43LTIuOS0xNy42LTctNDMuMy05LTUwLjQiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03MDkuNSAxNDEuMmM4LjUgMCAxNS44IDQgMTguMyAxMC4xIDE3LjYgNDEuOCA1MCAxOTAuMiA1NC4yIDIzMy4zIDEuMSA4LjQuNCAxNC41LTEuMSAxNy4yLTQuNiA3LjktMTUuMSAxNC4xLTIzLjIgMTQuMXMtOC41LS45LTEyLjMtNi4yYy00LjYtNi42LTE3LjMtODAuNi0yMC40LTk1LjEtMjcuOCA4LjgtNjcuMyAxNS45LTc4LjkgMTguMS02LjMgMTQuNS0xMC4yIDMwLjgtMTQuOCA0Ni4yLTMuMiAxMC4xLTQuNiAxNS0xNS41IDE1cy0yMS4xLTQuOC0yMi41LTE5LjRjLTMuOS0zOC4zIDc2LjQtMjE3LjkgODQuMi0yMjMuMiA5LjktNi42IDIyLjItMTAuMSAzMi0xMC4xbS00Ny4yIDE0NC45YzI0LjMtOS43IDQyLjYtMTQuMSA1Mi4xLTE1LjgtMy45LTIxLjktMTEuOS03Ni42LTE0LjEtNzYuNi0xLjggMC0yMi4yIDQ4LjktMzggOTIuNW0xMzIuOCAyNy45aDUzLjVjMS45IDMzLjcgMTIuMyA0OC4yIDM0LjggNDguMnMyOC44LTExLjIgMjguOC0yNS40YzAtMjIuMS0yMC42LTMyLjItNDQuMS00My40LTMyLjUtMTUuMy03MS40LTMyLjUtNzEuNC04M3MzMC4zLTcyLjkgNzguNS03Mi45IDg0LjEgMzEgODcuOSA4OS40aC01MmMtMi42LTI4LjgtMTQuMi00My44LTM0LjQtNDMuOHMtMjUuMSA5LTI1LjEgMjIuOGMwIDIwLjkgMjAuOSAzMSA0NS4zIDQyLjYgMzIuMiAxNS4zIDY5LjkgMzIuOSA2OS45IDgzLjRzLTMxLjQgNzUuNS04MS41IDc1LjUtODcuMS0zMi45LTkwLjEtOTMuNVptMTg1LjkgMGg1My41YzEuOSAzMy43IDEyLjMgNDguMiAzNC44IDQ4LjJzMjguOC0xMS4yIDI4LjgtMjUuNGMwLTIyLjEtMjAuNi0zMi4yLTQ0LjEtNDMuNC0zMi41LTE1LjMtNzEuNC0zMi41LTcxLjQtODNzMzAuMy03Mi45IDc4LjUtNzIuOSA4NC4xIDMxIDg3LjkgODkuNGgtNTJjLTIuNi0yOC44LTE0LjItNDMuOC0zNC40LTQzLjhzLTI1LjEgOS0yNS4xIDIyLjhjMCAyMC45IDIwLjkgMzEgNDUuMyA0Mi42IDMyLjIgMTUuMyA2OS45IDMyLjkgNjkuOSA4My40cy0zMS40IDc1LjUtODEuNSA3NS41LTg3LjEtMzIuOS05MC4xLTkzLjVabTE4OS4yLTE3Mi40aDE1NnY0Ni40aC05OS4xdjU3LjJoNzQuOHY0NS42aC03NC44djY2LjloOTkuMXY0NS42aC0xNTZ6bTQxNi4xIDBoODkuNGM1MS4yIDAgODAgMjcuNyA4MCA3MC4zcy0xMS42IDQ1LjYtMzQuNCA1Ny4yYzI1LjEgMTAuOCAzOC41IDMyLjIgMzguNSA2MC42IDAgNDQuMS0zMC43IDczLjctODMuNCA3My43aC05MC4xem01Ni41IDQ1LjJ2NjEuM2gyNy4zYzE4IDAgMzAuNy0xMC4xIDMwLjctMzAuM3MtMTIuNy0zMS0zMC43LTMxem0wIDEwNS41djY2LjJoMjcuN2MyMC42IDAgMzMuMy0xMS4yIDMzLjMtMzIuOXMtMTIuNy0zMy4zLTMzLjMtMzMuM3ptMTM1LjctMTUwLjdoNTYuOHYyMTUuOGg5OC40djQ2aC0xNTUuMnptMTgwLjcgMTY5LjgtNzQuMS0xNjkuOGg2MC42bDQzLjQgMTA2LjIgNDMtMTA2LjJoNThsLTc0LjQgMTY5Ljh2OTJoLTU2LjV6bS02MTIuNi0xNjkuOGg3OC45bDE1LjMgODYgMTUgODYgMjkuOS0xNzJoNzguNXYyNjEuOGgtNDkuN2wxLjEtMTI3LjkgMS4xLTgwLjQtMTQuNiA4MC40LTIzLjkgMTI3LjloLTQ2LjdsLTIzLjktMTI3LjktMTQuNi04MC40IDEuMSA4MC40IDEuMSAxMjcuOWgtNDguNnoiLz48L3N2Zz4="

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clsx = __webpack_require__(452);
	
	var _clsx2 = _interopRequireDefault(_clsx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageSlider = function (_Component) {
	  _inherits(ImageSlider, _Component);
	
	  function ImageSlider(props) {
	    _classCallCheck(this, ImageSlider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      activeIndex: 0
	    };
	
	    _this.showNextSlide = _this.showNextSlide.bind(_this);
	    return _this;
	  }
	
	  ImageSlider.prototype.componentDidMount = function componentDidMount() {
	    this.interval = setInterval(this.showNextSlide, this.props.interval);
	  };
	
	  ImageSlider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.interval) {
	      clearInterval(this.interval);
	    }
	  };
	
	  ImageSlider.prototype.showNextSlide = function showNextSlide() {
	    var nextSlide = (this.state.activeIndex + 1) % this.props.images.length;
	
	    this.setState({
	      activeIndex: nextSlide
	    });
	  };
	
	  ImageSlider.prototype.render = function render() {
	    var activeIndex = this.state.activeIndex;
	    var images = this.props.images;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'slider' },
	      images.map(function (_ref, index) {
	        var name = _ref.name,
	            src = _ref.src;
	        return _react2.default.createElement(
	          'div',
	          {
	            key: name,
	            className: (0, _clsx2.default)('slide', index === activeIndex && 'active', index === (activeIndex - 1 + images.length) % images.length && 'prev', index === (activeIndex + 1) % images.length && 'next')
	          },
	          _react2.default.createElement('img', { src: src, alt: name })
	        );
	      })
	    );
	  };
	
	  return ImageSlider;
	}(_react.Component);
	
	ImageSlider.defaultProps = {
	  interval: 5000
	};
	
	ImageSlider.propTypes = {
	  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    src: _propTypes2.default.string.isRequired
	  })).isRequired,
	  interval: _propTypes2.default.number
	};
	
	exports.default = ImageSlider;
	module.exports = exports['default'];

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlx = __webpack_require__(117);
	
	var _reactPlx2 = _interopRequireDefault(_reactPlx);
	
	var _vertical = __webpack_require__(101);
	
	var _vertical2 = _interopRequireDefault(_vertical);
	
	var _verticalMenu = __webpack_require__(99);
	
	var _verticalMenu2 = _interopRequireDefault(_verticalMenu);
	
	var _videoReact = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var verticalsParallax = [{
	  start: '.verticals',
	  end: '100%',
	  properties: [{
	    startValue: 0,
	    endValue: -60,
	    property: 'translateY',
	    unit: '%'
	  }]
	}];
	
	var generateUniqueRef = function generateUniqueRef() {
	  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ref';
	
	  return prefix + '-' + Math.random().toString(36).substr(2, 9);
	};
	
	var VerticalList = function (_Component) {
	  _inherits(VerticalList, _Component);
	
	  function VerticalList(props) {
	    _classCallCheck(this, VerticalList);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      activeVertical: 0,
	      isMobile: false,
	      isIDevice: false,
	      markerPosition: 0
	    };
	
	    _this.fullVideo = generateUniqueRef('fullVideo');
	    _this.fullVideoPlayer = generateUniqueRef('fullVideoPlayer');
	
	    _this.checkWidth = _this.checkWidth.bind(_this);
	    _this.changeVertical = _this.changeVertical.bind(_this);
	    _this.showNextVertical = _this.showNextVertical.bind(_this);
	    _this.handleFullVideoState = _this.handleFullVideoState.bind(_this);
	    _this.handleWatchNowClick = _this.handleWatchNowClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleModalCloseClick = _this.handleModalCloseClick.bind(_this);
	    return _this;
	  }
	
	  VerticalList.prototype.checkWidth = function checkWidth() {
	    // This method and the event listeners below exist so that the layout is
	    // responsive to browser resizing across all breakpoints
	    var width = typeof window !== 'undefined' ? window.innerWidth : 0;
	    this.setState({ isMobile: width < 1024 });
	  };
	
	  VerticalList.prototype.componentWillMount = function componentWillMount() {
	    // TODO: find a more robust solution for mobile vs desktop detection
	    // Matches our desktop breakpoint value
	    typeof window !== 'undefined' && window.addEventListener('resize', this.checkWidth);
	    this.checkWidth();
	  };
	
	  VerticalList.prototype.componentDidMount = function componentDidMount() {
	    var isIDevice = window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
	    var fullVideo = this.refs[this.fullVideo];
	    var fullVideoPlayer = this.refs[this.fullVideoPlayer];
	
	    this.setState({
	      isIDevice: isIDevice
	    });
	
	    if (fullVideoPlayer) {
	      fullVideoPlayer.subscribeToStateChange(this.handleFullVideoState);
	    }
	
	    if (isIDevice && fullVideo) {
	      fullVideo.querySelector('video').addEventListener('webkitendfullscreen', this.handleModalCloseClick);
	    }
	
	    this.intervalId = setInterval(this.showNextVertical, 10000);
	  };
	
	  VerticalList.prototype.componentWillUnmount = function componentWillUnmount() {
	    var fullVideo = this.refs[this.fullVideo];
	    if (this.intervalId) {
	      clearInterval(this.intervalId);
	    }
	
	    if (this.state.isIDevice && fullVideo) {
	      fullVideo.querySelector('video').removeEventListener('webkitendfullscreen', this.handleModalCloseClick);
	    }
	
	    typeof window !== 'undefined' && window.removeEventListener('resize', this.checkWidth);
	  };
	
	  VerticalList.prototype.changeVertical = function changeVertical(event) {
	    var _this2 = this;
	
	    event.preventDefault();
	    var verticalId = event.target.dataset.vertical;
	
	    this.setState({ activeVertical: Number(verticalId) }, function () {
	      return _this2.updateMarkerPosition();
	    });
	
	    // Clear the timer since the user has interacted with the menu
	    if (this.intervalId) {
	      clearInterval(this.intervalId);
	    }
	  };
	
	  VerticalList.prototype.updateMarkerPosition = function updateMarkerPosition() {
	    var activeItem = document.querySelector('.vertical-menu-item.is-active');
	    if (activeItem) {
	      this.setState({ markerPosition: activeItem.offsetTop });
	    }
	  };
	
	  VerticalList.prototype.showNextVertical = function showNextVertical() {
	    var _this3 = this;
	
	    var verticals = this.props.verticals;
	
	    var nextVertical = this.state.activeVertical + 1;
	
	    // Reset if next vertical id isn't found
	    if (nextVertical >= verticals.length) {
	      nextVertical = 0;
	    }
	
	    this.setState({ activeVertical: nextVertical }, function () {
	      return _this3.updateMarkerPosition();
	    });
	  };
	
	  VerticalList.prototype.handleFullVideoState = function handleFullVideoState(_ref) {
	    var ended = _ref.ended,
	        isFullscreen = _ref.isFullscreen,
	        paused = _ref.paused,
	        userActivity = _ref.userActivity;
	
	    if (ended && !isFullscreen) {
	      this.handleModalCloseClick();
	
	      if (this.state.isIDevice) {
	        this.refs[this.fullVideo].querySelector('video').webkitExitFullscreen();
	      }
	    }
	
	    if (userActivity) {
	      document.querySelector('.modal--close').classList.remove('hide');
	    } else if (!paused) {
	      document.querySelector('.modal--close').classList.add('hide');
	    }
	  };
	
	  VerticalList.prototype.handleWatchNowClick = function handleWatchNowClick() {
	    var fullVideo = this.refs[this.fullVideo];
	    var fullVideoPlayer = this.refs[this.fullVideoPlayer];
	
	    // Clear the timer since there is a user interaction
	    if (this.intervalId) {
	      clearInterval(this.intervalId);
	    }
	
	    fullVideo.parentElement.classList.add('is-active');
	    document.querySelector('body').classList.add('fullvideo--open');
	
	    fullVideoPlayer.play();
	  };
	
	  VerticalList.prototype.handleModalCloseClick = function handleModalCloseClick() {
	    var fullVideo = this.refs[this.fullVideo];
	    var fullVideoPlayer = this.refs[this.fullVideoPlayer];
	    fullVideo.parentElement.classList.remove('is-active');
	    document.querySelector('body').classList.remove('fullvideo--open');
	
	    fullVideoPlayer.pause();
	    fullVideoPlayer.load();
	  };
	
	  VerticalList.prototype.handleKeyDown = function handleKeyDown(event) {
	    event.preventDefault();
	
	    if (event.key === 'Enter') {
	      this.handleModalCloseClick();
	    }
	  };
	
	  VerticalList.prototype.render = function render() {
	    var _this4 = this;
	
	    var verticals = this.props.verticals;
	    var _state = this.state,
	        isMobile = _state.isMobile,
	        activeVertical = _state.activeVertical;
	
	
	    return _react2.default.createElement(
	      _reactPlx2.default,
	      {
	        disabled: true,
	        parallaxData: verticalsParallax,
	        className: 'verticals__parallax'
	      },
	      _react2.default.createElement(
	        'section',
	        { className: 'verticals' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper--max-width' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'vertical-list ul--reset' },
	            verticals.map(function (item, index) {
	              var vertical = item.node;
	              return _react2.default.createElement(_vertical2.default, {
	                activeVertical: activeVertical,
	                key: vertical.id,
	                index: index,
	                vertical: vertical,
	                isMobile: isMobile,
	                handleClick: _this4.handleWatchNowClick
	              });
	            })
	          ),
	          _react2.default.createElement(_verticalMenu2.default, {
	            activeVertical: this.state.activeVertical,
	            verticals: verticals,
	            onVerticalClick: this.changeVertical,
	            isMobile: isMobile,
	            markerPosition: this.state.markerPosition
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'verticals__fullvideo' },
	          _react2.default.createElement(
	            'div',
	            { className: 'video-wrapper', ref: this.fullVideo },
	            _react2.default.createElement(
	              _videoReact.Player,
	              {
	                ref: this.fullVideoPlayer,
	                className: 'video',
	                aspectRatio: '16:9',
	                loop: false,
	                playsInline: true,
	                preload: 'none',
	                src: verticals[this.state.activeVertical].node.cta.url.path
	              },
	              _react2.default.createElement(_videoReact.BigPlayButton, { disabled: true }),
	              _react2.default.createElement(_videoReact.ControlBar, null),
	              _react2.default.createElement(_videoReact.Shortcut, null)
	            ),
	            _react2.default.createElement('div', {
	              className: 'modal--close',
	              onClick: this.handleModalCloseClick,
	              onKeyDown: this.handleKeyDown,
	              tabIndex: 0
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return VerticalList;
	}(_react.Component);
	
	VerticalList.propTypes = {
	  verticals: _propTypes2.default.array.isRequired
	};
	
	exports.default = VerticalList;
	module.exports = exports['default'];

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VerticalMenu = function VerticalMenu(_ref) {
	  var verticals = _ref.verticals,
	      onVerticalClick = _ref.onVerticalClick,
	      activeVertical = _ref.activeVertical,
	      markerPosition = _ref.markerPosition;
	
	  var classes = 'vertical-menu-item';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'vertical-menu-wrapper' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'vertical-menu ul--reset' },
	      verticals.map(function (item, index) {
	        var vertical = item.node;
	        var label = vertical.label.split('>')[0].trim();
	        var isActiveVertical = activeVertical === index;
	        return _react2.default.createElement(
	          'li',
	          {
	            key: vertical.id,
	            className: isActiveVertical ? classes + ' is-active' : classes
	          },
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'link--inverse-menu',
	              'data-vertical': index,
	              href: '',
	              onClick: onVerticalClick
	            },
	            label.length > 25 ? label.split(' ').slice(0, 3).join(' ') : label,
	            '  '
	          )
	        );
	      })
	    ),
	    _react2.default.createElement('span', {
	      className: 'vertical-menu__marker',
	      style: { transform: 'translateY(' + markerPosition + 'px)' }
	    })
	  );
	};
	
	VerticalMenu.propTypes = {
	  activeVertical: _propTypes2.default.number,
	  verticals: _propTypes2.default.array,
	  onVerticalClick: _propTypes2.default.func.isRequired,
	  markerPosition: _propTypes2.default.number.isRequired
	};
	
	exports.default = VerticalMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _videoReact = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VerticalVideo = function (_Component) {
	  _inherits(VerticalVideo, _Component);
	
	  function VerticalVideo(props) {
	    _classCallCheck(this, VerticalVideo);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.play = _this.play.bind(_this);
	    _this.pause = _this.pause.bind(_this);
	    return _this;
	  }
	
	  VerticalVideo.prototype.componentDidMount = function componentDidMount() {
	    // Set initially active vertical to play
	    var _props = this.props,
	        activeVertical = _props.activeVertical,
	        index = _props.index;
	
	
	    if (activeVertical === index) {
	      this.play();
	    }
	  };
	
	  VerticalVideo.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _props2 = this.props,
	        activeVertical = _props2.activeVertical,
	        index = _props2.index;
	
	
	    if (prevProps.activeVertical !== this.props.activeVertical) {
	      // Play active vertical
	      if (activeVertical === index) {
	        this.play();
	      } else {
	        this.pause();
	      }
	    }
	  };
	
	  VerticalVideo.prototype.play = function play() {
	    this.refs.player.play();
	  };
	
	  VerticalVideo.prototype.pause = function pause() {
	    this.refs.player.pause();
	  };
	
	  VerticalVideo.prototype.render = function render() {
	    var _props3 = this.props,
	        vertical = _props3.vertical,
	        isMobile = _props3.isMobile;
	
	    var screen = isMobile ? 'mobile' : 'desktop';
	
	    // On deskop, videos have a defined size.
	    // Until then, fluid == true so the width and height props are ignored
	    // by react-video.
	    return _react2.default.createElement(
	      _videoReact.Player,
	      {
	        className: 'video video--vertical',
	        fluid: isMobile,
	        height: 'auto',
	        loop: true,
	        muted: true,
	        playsInline: true,
	        poster: vertical['image_' + screen].url,
	        preload: 'auto',
	        ref: 'player',
	        src: vertical['video_' + screen].file.url,
	        width: 976
	      },
	      _react2.default.createElement(_videoReact.BigPlayButton, { disabled: true }),
	      _react2.default.createElement(_videoReact.ControlBar, { disabled: true }),
	      _react2.default.createElement(_videoReact.Shortcut, { disabled: true })
	    );
	  };
	
	  return VerticalVideo;
	}(_react.Component);
	
	VerticalVideo.propTypes = {
	  vertical: _propTypes2.default.object.isRequired,
	  isMobile: _propTypes2.default.bool.isRequired,
	  isVisible: _propTypes2.default.bool,
	  activeVertical: _propTypes2.default.number
	};
	
	exports.default = VerticalVideo;
	module.exports = exports['default'];

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _verticalVideo = __webpack_require__(100);
	
	var _verticalVideo2 = _interopRequireDefault(_verticalVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vertical = function Vertical(_ref) {
	  var index = _ref.index,
	      vertical = _ref.vertical,
	      activeVertical = _ref.activeVertical,
	      isMobile = _ref.isMobile,
	      handleClick = _ref.handleClick;
	
	  var classes = 'vertical-item';
	  if (activeVertical === index) {
	    classes = 'vertical-item is-active';
	  }
	
	  return _react2.default.createElement(
	    'li',
	    { className: classes },
	    _react2.default.createElement(_verticalVideo2.default, {
	      index: index,
	      vertical: vertical,
	      isMobile: isMobile,
	      activeVertical: activeVertical
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'vertical-item__details' },
	      _react2.default.createElement(
	        'span',
	        { className: 'vertical-item__platform' },
	        vertical.platform
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'vertical-item__title' },
	        vertical.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'vertical-item__description' },
	        _react2.default.createElement(
	          'p',
	          null,
	          vertical.description
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'vertical-item__footer' },
	        _react2.default.createElement(
	          'span',
	          {
	            id: vertical.title.trim().replace(/\s+/g, '-'),
	            className: 'vertical-item__cta',
	            onClick: handleClick
	          },
	          vertical.cta.title
	        )
	      )
	    )
	  );
	};
	
	Vertical.propTypes = {
	  activeVertical: _propTypes2.default.number.isRequired,
	  index: _propTypes2.default.number.isRequired,
	  vertical: _propTypes2.default.object.isRequired,
	  isMobile: _propTypes2.default.bool.isRequired,
	  handleClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = Vertical;
	module.exports = exports['default'];

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _headerNew = __webpack_require__(26);
	
	var _headerNew2 = _interopRequireDefault(_headerNew);
	
	var _footerNew = __webpack_require__(15);
	
	var _footerNew2 = _interopRequireDefault(_footerNew);
	
	var _heroVideo = __webpack_require__(41);
	
	var _heroVideo2 = _interopRequireDefault(_heroVideo);
	
	var _scrollingBanner = __webpack_require__(97);
	
	var _scrollingBanner2 = _interopRequireDefault(_scrollingBanner);
	
	var _verticalList = __webpack_require__(98);
	
	var _verticalList2 = _interopRequireDefault(_verticalList);
	
	var _imageSlider = __webpack_require__(406);
	
	var _imageSlider2 = _interopRequireDefault(_imageSlider);
	
	var _attnAssemblyLogo = __webpack_require__(1209);
	
	var _attnAssemblyLogo2 = _interopRequireDefault(_attnAssemblyLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global graphql  */
	var images = [{
	  name: 'Assembly image 1',
	  src: '/img/creativeshop/assembly-image-1.png'
	}, {
	  name: 'Assembly image 2',
	  src: '/img/creativeshop/assembly-image-2.png'
	}, {
	  name: 'Assembly image 3',
	  src: '/img/creativeshop/assembly-image-3.png'
	}];
	
	var CreativeShopPage = function CreativeShopPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'wrapper--page-dark page--creative-shop' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Creative Shop - ATTN:' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'home-header' },
	      _react2.default.createElement(_headerNew2.default, { theme: 'dark' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'hero--fullbleed' },
	        _react2.default.createElement(_heroVideo2.default, {
	          desktopPosterSrc: data.hero.image_desktop.url,
	          mobilePosterSrc: data.hero.image_mobile.url,
	          desktopVideoSrc: data.hero.loop_desktop.file.url,
	          mobileVideoSrc: data.hero.loop_mobile.file.url
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'creative-shop-intro' },
	      _react2.default.createElement(
	        'div',
	        { className: 'creative-shop-intro__body' },
	        'We accelerate growth for brands, putting them at the center of culture so they become the center of attention.'
	      )
	    ),
	    _react2.default.createElement(_scrollingBanner2.default, {
	      background: 'grey',
	      text: 'Capabilities',
	      iconColor: 'red',
	      length: 10
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: 'creative-shop-capabilities' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'capabilities__list' },
	        _react2.default.createElement(
	          'li',
	          { className: 'capabilities__item' },
	          'Brand Strategy.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'capabilities__item' },
	          'Fully integrated Campaign Development.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'capabilities__item' },
	          'Comms Planning.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'capabilities__item' },
	          'Social Strategy and Community Management.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'capabilities__item' },
	          'Social Content Creation.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'capabilities__item' },
	          'End-to-end Production.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'capabilities__item' },
	          'ATTN: Creator CoLab',
	          _react2.default.createElement(
	            'sup',
	            null,
	            '\u2122'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'capabilities__item' },
	          'ATTN: Assembly',
	          _react2.default.createElement(
	            'sup',
	            null,
	            '\u2122'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_scrollingBanner2.default, {
	      background: 'black',
	      text: 'Our work',
	      iconColor: 'red',
	      length: 10
	    }),
	    _react2.default.createElement(_verticalList2.default, { verticals: data.allDrupalProject.edges }),
	    _react2.default.createElement(_scrollingBanner2.default, {
	      background: 'grey',
	      text: 'Creator CoLab',
	      iconColor: 'red',
	      length: 10
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: 'creator-colab' },
	      _react2.default.createElement(
	        'div',
	        { className: 'creator-colab__logo' },
	        'ATTN: Creator CoLab',
	        _react2.default.createElement(
	          'sup',
	          null,
	          '\u2122'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'creator-colab__grid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'creator-colab__video' },
	          _react2.default.createElement(_heroVideo2.default, {
	            desktopPosterSrc: data.creatorCoLab.image_desktop.url,
	            mobilePosterSrc: data.creatorCoLab.image_mobile.url,
	            desktopVideoSrc: data.creatorCoLab.loop_desktop.file.url,
	            mobileVideoSrc: data.creatorCoLab.loop_mobile.file.url
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'creator-colab__info' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'creator-colab__heading' },
	            'Introducing ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'ATTN: Creator CoLab'
	            ),
	            ', where creators and brands unite to unlock the power of influence.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'creator-colab__description' },
	            'Our Creator CoLab\u201D connects brands to creators in a way that prioritizes meaningful engagement. Unlike standard influencer agencies who execute on one-off transactions, we build creator cohorts that offer resources, education, and networking opportunities, helping brands form authentic, mission-aligned partnerships. This approach fosters collaboration, strengthens the creator economy, and ensures deeper, sustainable relationships for both brands and creators.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'creator-colab__description' },
	            'We use advanced AI to match creators to campaigns, including content, events, appearances, and more. Combining data and human insight, we deliver authentic storytelling and measurable results.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'creator-colab__description' },
	            'Whether you\'re a creator seeking growth or a brand crafting powerful campaigns, ATTN: Creator CoLab blends creativity and analytics to forge meaningful connections.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_scrollingBanner2.default, {
	      background: 'pink',
	      text: 'ATTN: Assembly',
	      iconColor: 'red',
	      length: 10
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: 'creative-shop-assembly' },
	      _react2.default.createElement(
	        'div',
	        { className: 'assembly__images' },
	        _react2.default.createElement(_imageSlider2.default, { images: images })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'assembly__headline' },
	        'Our proprietary research tool'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'assembly__logo' },
	        _react2.default.createElement('img', { src: _attnAssemblyLogo2.default, alt: 'ATTN Assembly' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'assembly__copy' },
	        'We are so audience obsessed that we built our own panel of 5,000+ culturally connected doers and deciders'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'assembly__grid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'assembly__item' },
	          _react2.default.createElement(
	            'p',
	            { className: 'assembly__item__heading' },
	            'UNCOVERING INSIGHTS &',
	            _react2.default.createElement('br', null),
	            ' EMERGING TRENDS'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'assembly__item__description' },
	            'Our panel allows us to uncover powerful consumer insights to inform strategy and inspire break-through work that resonates with consumers'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'assembly__item' },
	          _react2.default.createElement(
	            'p',
	            { className: 'assembly__item__heading' },
	            'PRE-TESTING',
	            _react2.default.createElement('br', null),
	            ' PLATFORM'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'assembly__item__description' },
	            'We can get an early read on conceptual directions and executions in advance, allowing us to optimize based on learnings before we go to market.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'assembly__item' },
	          _react2.default.createElement(
	            'p',
	            { className: 'assembly__item__heading' },
	            'CUSTOM BRAND',
	            _react2.default.createElement('br', null),
	            ' STUDIES'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'assembly__item__description' },
	            'We can explore brand perceptions and measure the effectiveness of campaigns through Quantitative and Qualitative brand studies.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_footerNew2.default, null)
	  );
	};
	
	CreativeShopPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = CreativeShopPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-creativeshop-js-babe1d06bf40452fe726.js